__turbopack_context__.v({
  "dl": "StHJqq_dl",
  "link": "StHJqq_link",
  "root": "StHJqq_root",
  "title": "StHJqq_title",
});
